import React from 'react';
import { Link } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <h3>About Us</h3>
                    <p>Founded by Hamed Khan in 2021, Lets Make a Deal is a trusted real estate consultancy based in Bangalore. Working independently and in collaboration with top A-category builders, we specialize in seamless property deals and have a strong track record of successful sale closings.</p>
                </div>

                <div className="footer-section">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</Link></li>
                        <li><Link to="/properties" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Properties</Link></li>
                        <li><Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>About Us</Link></li>
                        <li><Link to="/contact" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Contact</Link></li>
                    </ul>
                </div>

                <div className="footer-section">
                    <h3>Contact Info</h3>
                    <ul>
                        <li>Email: sales@letsmakeadeal.co.in</li>
                        <li>WhatsApp: 8792721942 / 7204299809</li>
                        <li>RERA: PRM/KA/RERA/1251/446/AG/210107/002168</li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="social-links">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                        <i className="fab fa-facebook"></i>
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                        <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                        <i className="fab fa-linkedin"></i>
                    </a>
                </div>
                <p>&copy; {new Date().getFullYear()} Let's Make A Deal. All rights reserved.</p>
            </div>

            <WhatsAppButton />
        </footer>
    );
};

export default Footer;